<template>
  <router-link
    :to="`${routers.settingTeamRoles}/manage/${data?.roleId}`"
    class="tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline"
    @click.stop="$emit('close-menu')"
  >
    <div
      class="tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[25px]"
    >
      <span class="role-topic-title">{{ data?.roleName }}</span>
      <div class="role-topic-role">
        <span>
          {{ data?.permissionLevel }}
        </span>
      </div>
    </div>
    <IconRight />
  </router-link>
</template>

<script setup lang="ts">
import { routers } from "@/utils/constants";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";

const props = defineProps<{
  data: any;
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
}>();
</script>

<style scoped>
.role-topic-title {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #387dff;
  user-select: none;
}
.role-topic-role {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  border-radius: 4px;
  padding: 3px 5px;
  background-color: rgba(239, 240, 241, 0.5);
  & > span {
    font-family: Poppins, sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: #231f20;
  }
}
</style>
